import React__default from 'react';
import { GlobalStyles } from '@mui/material';
import { NiceScrollbar, ToasterStyle } from '../utils/css.js';

var NiceScrollGlobalStyle = React__default.createElement(GlobalStyles, { styles: NiceScrollbar });
var ToasterGlobalStyle = React__default.createElement(GlobalStyles, { styles: ToasterStyle });
var Reset = (React__default.createElement(GlobalStyles, { styles: function (theme) { return ({
        body: {
            padding: 0,
            margin: 0,
            fontSize: "100%",
            overflow: "overlay",
            colorScheme: "dark",
            fontFamily: theme.typography.fontFamily,
            background: theme.palette.backgrounds.body,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            color: theme.palette.neutral000,
            backgroundPositionX: "center",
            backgroundPositionY: "top",
        },
        a: {
            color: "inherit",
            textDecoration: "none",
        },
        "*": {
            boxSizing: "border-box",
        },
        ul: {
            padding: 0,
            margin: 0,
            listStyleType: "none",
        },
    }); } }));
var GlobalAppStyle = function () {
    return (React__default.createElement(React__default.Fragment, null,
        Reset,
        ToasterGlobalStyle,
        !!window.isSafari && NiceScrollGlobalStyle));
};

export { GlobalAppStyle };
